module.exports = __webpack_public_path__ + "img/qrCodeWhite.56191f7e.svg";